
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/performing-artists",
      function () {
        return require("private-next-pages/mahashivratri/performing-artists/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/performing-artists"])
      });
    }
  